import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, GetOneResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  IBomHeaderJob,
  IBomHeaderRequestPayload,
  IBomsByPart,
  ILinesByPart,
  IReportSummary,
  IReportSummaryRequestPayload,
} from 'reports/types';

export const getBomHeaderReport = async (
  requestPayload: IBomHeaderRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IBomHeaderJob>> => {
  const { data } = await partfinitiClient.get(
    `/support/report/bom-header?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordsFromServer<IBomHeaderJob>(data?.data, data?.recordsFiltered);
};

export const getLinesByPartReport = async (
  requestPayload: IBomHeaderRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ILinesByPart>> => {
  const { data } = await partfinitiClient.get(
    `/support/report/lines-by-part?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordsFromServer<ILinesByPart>(data?.data);
};

export const getBomsByPartReport = async (
  requestPayload: IBomHeaderRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IBomsByPart>> => {
  const { data } = await partfinitiClient.get(
    `/support/report/boms-by-part?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordsFromServer<IBomsByPart>(data?.data);
};

export const getSupportReportSummary = async (
  requestPayload: IReportSummaryRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IReportSummary>> => {
  const { data } = await partfinitiClient.get(
    `/support/report/summary?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IReportSummary>(data.data);
};

export const getExternalLocationRegionsAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<string>> => {
  const { data } = await partfinitiClient.get(
    `/support/report/external-location-region-autocomplete?${getQueryStringToSnakeCase(
      requestPayload,
      {
        removeNullValues: true,
      }
    )}`,
    signal
  );

  return mapRecordsFromServer<string>(data?.data.external_location_regions, data?.data.total_count);
};
